/** This common object wraps around things we cannot stub
 * like window.locations methods which are locked for security reasons
 * But, we can stub Location's methods */
export const LocationAlias = {
  assign(url: string) {
    window.location.assign(url)
  },
}
